/** https://mikemcl.github.io/decimal.js/ */
import Decimal from 'decimal.js';

export * from 'decimal.js';

/** legacy approach  */
export const divide = (a: number, b: number) => Decimal.div(a, b).toNumber();
export const subtract = (a: number, b: number) => Decimal.sub(a, b).toNumber();
export const multiply = (a: number, b: number) => Decimal.mul(a, b).toNumber();
export const sum = (a: number, b: number) => Decimal.sum(a, b).toNumber();
/** @deprecated don't use it, use decimal.js directly */
export const round = (a: number, n = 1) => {
  const x = new Decimal(a);
  return x.toDecimalPlaces(n, Decimal.ROUND_FLOOR).toNumber();
};
export const max = (...a: number[]) => Decimal.max(...a).toNumber();
export const min = (...a: number[]) => Decimal.min(...a).toNumber();
